import { isNullish } from '@sas/nova-core/typeguards';

/**
 * A collection of functions useful when working with arrays
 * Many of these were ported over from dm-commons-ui
 * (https://gitlab.sas.com/dmv-gerrit/dm-commons-ui/-/blob/ae973a05d946490a94713c23629af7580584965a/src/main/typescript/sas/dm/commons/util/ArrayUtils.ts)
 */

/**
 * finds the item's index in the array using the given equality test
 * @param array
 * @param toFind
 * @param equalityTest function that takes two objects and returns true if they should be considered equal, false otherwise
 * @param startIndex (optional)
 * @returns {number}
 */
export const indexOfEqualityTest = (array, toFind, equalityTest, startIndex = 0) => {
  if (!array) {
    return -1;
  }
  let startix = 0;
  if (startIndex < array.length && startIndex >= 0) {
    startix = startIndex;
  }
  const arrayLength = array.length;
  let counter = 0;
  while (counter < arrayLength) {
    let i = counter + startix;
    if (i > arrayLength - 1) {
      i = i - arrayLength;
    }
    if (equalityTest(array[i], toFind)) {
      return i;
    }
    counter++;
  }
  return -1;
};
export const isEmpty = arr => {
  if (isNullish(arr)) {
    return true;
  }
  return !(arr.hasOwnProperty('length') && arr.length > 0);
};

/**
 *
 * @param arr1
 * @param arr2
 * @param equalityTest  to determine if two items should be considered "equal" the equalityTest parameter should be
 * a function that takes two objects and returns true if they should be considered equal.
 * @param returnItemsFromRight - if items are "equal" return the item from arr2 (optional)
 * @param matchCallback - callback that is fired when equivalent items are found (optional)
 * @returns Array<any> an array of items that are common between arr1 and arr2 using an equality test function
 */
export const inCommon = (arr1, arr2, equalityTest, returnItemsFromRight = false, matchCallback) => {
  const common = [];
  if (isEmpty(arr1) || isEmpty(arr2)) {
    return common;
  }
  const arr1Copy = arr1.concat();
  const arr2Copy = arr2.concat();
  while (arr1Copy.length > 0) {
    const subject = arr1Copy.shift();
    if (isNullish(subject)) {
      continue;
    }
    const index = indexOfEqualityTest(arr2Copy, subject, equalityTest);
    if (index >= 0) {
      if (returnItemsFromRight) {
        common[common.length] = arr2Copy[index];
      } else {
        common[common.length] = subject;
      }
      if (!!matchCallback) {
        matchCallback(subject, arr2Copy[index]);
      }
      arr2Copy.splice(index, 1);
    }
  }
  return common;
};
export const byReferenceEquality = (a, b) => a === b;
//# sourceMappingURL=array.js.map